import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const AuthCallback = () => {
  const { isAuthenticated, isLoading, error } = useAuth0();
  const navigate = useNavigate();
  const [authError, setAuthError] = useState(null);

  useEffect(() => {
    // Check for URL parameters that might indicate an error
    const urlParams = new URLSearchParams(window.location.search);
    const errorParam = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');

    if (errorParam) {
      setAuthError({
        error: errorParam,
        description: errorDescription || 'Authentication failed'
      });
      return;
    }

    if (!isLoading) {
      if (isAuthenticated) {
        navigate('/'); // Redirect to dashboard after successful authentication
      } else if (error) {
        setAuthError({
          error: 'authentication_failed',
          description: error.message || 'Authentication failed'
        });
      } else {
        navigate('/login'); // Redirect to login if something went wrong
      }
    }
  }, [isAuthenticated, isLoading, navigate, error]);

  // Show error message if there's an authentication error
  if (authError) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
          <div className="mb-6">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 19.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Access Denied</h2>
            <p className="text-gray-600 mb-4">
              {authError.error === 'access_denied' || authError.error === 'user_blocked' 
                ? 'Your account is currently inactive. Please contact your organization\'s Shelter Ready administrator.'
                : authError.description}
            </p>
            <p className="text-sm text-gray-500 mb-6">
              Please contact your administrator if you believe this is an error.
            </p>
          </div>
          <button
            onClick={() => navigate('/login')}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors"
          >
            Return to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>Loading...</div>
  );
};

export default AuthCallback;
